import React, { useEffect, useState } from "react";
import {
  Close,
  DescriptionOutlined,
  NorthEast,
  SchoolOutlined,
} from "@mui/icons-material";
import "../../css/StudentLoginModal.css";

export const APPLICANT_PORTAL_URL = "https://applicant.safapply.com/nti";
const STUDENT_PORTAL_URL = "https://my.nti.edu.ng";

const newStudentPortals = [
  { title: "Degree Portal", link: "https://nti.safsrms.com" },
  { title: "Diploma Portal", link: "https://nti_diploma.safsrms.com" },
  { title: "NCE Portal", link: "https://nti_nce.safsrms.com" },
];

const ANIMATION_MS = 250;

function StudentLoginModal({ open, onClose }) {
  const [tab, setTab] = useState("returning");
  const [mounted, setMounted] = useState(open);
  const [visible, setVisible] = useState(false);

  // Keep the modal mounted while it animates out.
  useEffect(() => {
    if (open) {
      setMounted(true);
      const id = requestAnimationFrame(() =>
        requestAnimationFrame(() => setVisible(true))
      );
      return () => cancelAnimationFrame(id);
    }
    setVisible(false);
    const t = setTimeout(() => {
      setMounted(false);
      setTab("returning");
    }, ANIMATION_MS);
    return () => clearTimeout(t);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!mounted) return null;

  const isNew = tab === "new";

  return (
    <div
      className={`slm_overlay ${visible ? "slm_visible" : ""}`}
      onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        className="slm_modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="slm_title"
      >
        <button className="slm_close" onClick={onClose} aria-label="Close">
          <Close />
        </button>

        <h2 id="slm_title" className="slm_title">
          Student login
        </h2>
        <p className="slm_subtitle">Choose your student category to continue</p>

        <div className={`slm_tabs ${isNew ? "slm_tabs_new" : ""}`} role="tablist">
          <span className="slm_tab_indicator" aria-hidden="true" />
          <button
            role="tab"
            aria-selected={!isNew}
            className={`slm_tab ${!isNew ? "slm_tab_active" : ""}`}
            onClick={() => setTab("returning")}
          >
            Returning students
          </button>
          <button
            role="tab"
            aria-selected={isNew}
            className={`slm_tab ${isNew ? "slm_tab_active" : ""}`}
            onClick={() => setTab("new")}
          >
            New students
          </button>
        </div>

        <div className="slm_panel" key={tab}>
          {isNew ? (
            <>
              <div className="slm_icon">
                <DescriptionOutlined />
              </div>
              <h3 className="slm_heading">Welcome</h3>
              <p className="slm_text">Continue to your registration portal</p>
              <div className="slm_portals">
                {newStudentPortals.map((portal) => (
                  <a
                    key={portal.title}
                    href={portal.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="slm_portal"
                  >
                    <DescriptionOutlined className="slm_portal_icon" />
                    <span className="slm_portal_body">
                      <span className="slm_portal_title">{portal.title}</span>
                      <span className="slm_portal_text">
                        Start or continue registration
                      </span>
                    </span>
                    <NorthEast className="slm_portal_arrow" />
                  </a>
                ))}
              </div>
            </>
          ) : (
            <>
              <div className="slm_icon">
                <SchoolOutlined />
              </div>
              <h3 className="slm_heading">Welcome back</h3>
              <p className="slm_text">
                Access your student account with your existing student login
                details to continue your studies
              </p>
              <a
                href={STUDENT_PORTAL_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="slm_primary_btn"
              >
                Login to student portal
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default StudentLoginModal;
